// 채널톡 서비스 
// 참고: https://developers.channel.io/reference/web-quickstart-kr

import * as ChannelService from '@channel.io/channel-web-sdk-loader';

// loadScript는 void를 반환하므로 Promise를 반환하지 않음
const isMobile = () => {
  return window.innerWidth <= 768;
}

export function loadChannelTalk(): void {
  if (isMobile()) return;
  ChannelService.loadScript();
}

export function bootChannelTalk(options: any = {}): void {
  if (isMobile()) return;
  const defaultOptions = {
    "pluginKey": "892f17b2-e49f-4088-a821-077ad325926d"
  };
  
  const mergedOptions = { ...defaultOptions, ...options };
  
  ChannelService.boot(mergedOptions);
}

// 회원 정보가 있을 경우 회원으로 부트
export function bootWithMember(memberId: string, profile: any = {}): void {
  bootChannelTalk({
    "memberId": memberId,
    "profile": profile
  });
}

// 채널톡 종료
export function shutdownChannelTalk(): void {
  ChannelService.shutdown();
}

// 채널톡 창 열기
export function openChannelTalk(): void {
  ChannelService.showMessenger();
}

// 채널톡 창 닫기
export function closeChannelTalk(): void {
  ChannelService.hideMessenger();
}

// 새 채팅을 문구가 입력된 상태로 연다(유저는 전송만). 클릭 이벤트 안에서 호출할 것(SDK 주의: iOS Safari).
// 반환값 = 모바일 조기 반환 여부(false)일 뿐, true가 부트 성공을 보장하지는 않는다.
export function openChatWithMessage(message: string): boolean {
  if (isMobile()) return false;
  ChannelService.openChat(undefined, message);
  return true;
}

export const ChannelTalk = {
  load: loadChannelTalk,
  boot: bootChannelTalk,
  bootWithMember,
  shutdown: shutdownChannelTalk,
  open: openChannelTalk,
  close: closeChannelTalk
};

export default ChannelTalk; 